

//  get /api/pc/mcd/follow/order 
import {
    defineRequest,
} from '@/lib/fetch-tools';
import { FissionResponse } from './types';

export const apiPcMcdFollowOrder = defineRequest<
  FissionResponse<{}>,
  {
      orderNo: string;
      uid: string;
    // Parameters for the follow order API
  }
>('/api/pc/mcd/follow/order', {
  useCache: false,
});
